import fetchTemplatesData from './fetch-templates-data';
import fetchTemplateBySlug from './fetch-template-by-slug';

export default {
  fetchTemplatesData,
  fetchTemplateBySlug,
};
